module.exports = __webpack_public_path__ + "img/2025-05-09a_5.a05cfadd.jpg";